import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { format } from "date-fns";
import { invokeGetApi } from "../utils/utils";
import { cleanParams, splitFilesFolders } from "../utils/apiHelpers";
;

export const useRepoQuery = ({
  token,
  endpoint,
  queryKey,
  view,
  page,
  search,
  filters,
  folderId,
  enabled,
  is_all = null
}) => {

  return useQuery({

    queryKey: [queryKey, page, search, JSON.stringify(filters), folderId],
    // enabled: enabled === undefined ? true : enabled,

    queryFn: async () => {

      const params = cleanParams({
        view,
        page,
        search,
        folder_id: folderId,
        file_type: filters?.file_type?.join(","),
        action: filters?.actions?.join(","),
        start_date: filters?.start_date
          ? format(new Date(filters.start_date), "yyyy-MM-dd")
          : null,
        end_date: filters?.end_date
          ? format(new Date(filters.end_date), "yyyy-MM-dd")
          : null,
          upload_type : filters?.upload_type,
          is_all
      });

      const response = await invokeGetApi(token, endpoint, params);

      if (endpoint === "activity-logs/") {
        return {
          total: response?.count,
          logs: response?.data,
          count: response?.count
        };
      }

      const data =
        response?.data?.items || response?.data || response?.items || [];

      const split = splitFilesFolders(data);
      return {
        ...split,
        count: response?.count,
        totalFiles:response?.files_count,
        totalFolders:response?.folders_count,
        ai_assistant_folder : response?.data?.ai_assistant_folder,
        storage : response?.data?.storage?.used_percentage,
        current_folder: response?.data?.current_folder || null,
      };
    },

    enabled: enabled === undefined ? true : enabled,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData // v5: replaces keepPreviousData: true
  });
};